export type ChargeOutcome = 'in_progress' | 'completed';

export type ReadingKind = 'runningTotal' | 'spot' | 'limit';

export function deliveredEnergyKwh(input: {
  totalEnergyKwh: number | null;
  startEnergyKwh: number | null;
  endEnergyKwh: number | null;
}): number | null {
  if (input.totalEnergyKwh != null) {
    return input.totalEnergyKwh;
  }
  if (input.startEnergyKwh != null && input.endEnergyKwh != null) {
    return input.endEnergyKwh - input.startEnergyKwh;
  }
  return null;
}

export function chargeOutcome(input: {
  isCompleted: boolean | null;
  stoppedAt: string | null;
}): ChargeOutcome {
  if (input.isCompleted !== true && input.stoppedAt == null) {
    return 'in_progress';
  }
  return 'completed';
}

export function chargeEndLabelKey(outcome: ChargeOutcome): string {
  if (outcome === 'in_progress') {
    return 'stillCharging';
  }
  return 'completed';
}

export function faultLabelKey(faultType: string): string | null {
  const normalized = faultType.replace(/[\s_-]+/g, '').toLowerCase();
  if (normalized === 'connectorlockfailure') {
    return 'plugWouldNotLock';
  }
  return null;
}

export function humanizeStoredToken(value: string): string {
  const spaced = value
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
  if (!spaced) {
    return value;
  }
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function readingKind(
  parameter: string,
  measureType: string,
): ReadingKind {
  const measure = measureType.replace(/[\s_]+/g, '').toLowerCase();
  const param = parameter.replace(/[\s_]+/g, '').toLowerCase();
  if (measure === 'setpoint' || param === 'setpoint') {
    return 'limit';
  }
  if (param.includes('energy')) {
    return 'runningTotal';
  }
  return 'spot';
}
